// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'babel-polyfill'
import Vue from 'vue'
import './globals.js'
import router from './router'
import Survey from './Survey'
import AppContent from './components/AppContent'
import store from '@/components/store.js'
import { i18n } from '@/components/i18n.js'
import VueI18n from 'vue-i18n'
import { Validator, install as VeeValidate } from 'vee-validate/dist/vee-validate.minimal.esm.js'
import { required, email } from 'vee-validate/dist/rules.esm.js'
// import VeeValidate, { Validator } from 'vee-validate'

import Vue2TouchEvents from 'vue2-touch-events'

import validationLocale from '@/languages/test.js'

Validator.extend('required', required)
Validator.extend('email', email)
Vue.use(VeeValidate, {
  locale: 'en',
  dictionary: {
    en: validationLocale,
    de: validationLocale,
    fr: validationLocale
  },
  events: 'change'
})
// VeeValidate.Validator.extend('required', Rules.required)
// VeeValidate.Validator.extend('email', Rules.email)

Vue.use(Vue2TouchEvents, {
  longTapTimeInterval: 100
})
Vue.use(VueI18n)

Vue.config.productionTip = false

new Vue({
  i18n,
  store,
  router,
  el: '#app',
  template: '<survey/>',
  components: { Survey, AppContent }
})



// WEBPACK FOOTER //
// ./src/main.js